import React, { useEffect, useState  } from 'react';
import { Formik } from "formik";
import { Row, Table, Modal } from "react-bootstrap";
import InputField from "../InputField/InputField";
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';
import Multiselect from 'multiselect-react-dropdown';

const ApprovalSetting =(props) => {
    
    const [cartDetails, setCartDetails] = useState(false);
    const [justForShow, setJustForShow] = useState(false);
    const approvers = props.approvers?.[0];
    const { updateSelectedApprover } = props;

    const addRemark = (value,id)=>{
        cartDetails[`approver${id}comment`]=value;
        setCartDetails(cartDetails);
    }

    const handleClick = async (event) => {
        const remark=cartDetails[`approver${event.lvl}comment`];
        if(event.result ==='a' || (event.result ==='r' && remark))
        {
            setCartDetails(false);
            const jsonData={
                approval: {
                 level:event.lvl,
                 result:event.result ==='a'?"approve":"reject",
                 remark:remark
                }
            };
            await Axios.post(`/cart/approval/${cartDetails.refnum}`,jsonData)
                .then(async (data) => {
                    if (data.data.success) {
                        setCartDetails(data.data.data.carth)
                        toast.success(`${event.result === 'a' ? "Approved" : "Rejected"} successfully.`, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 3000,
                            transition: Slide,
                        });
                    }
                    else {
                        toast.error(data.data.error, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 3000,
                            transition: Slide,
                        });
                    }
                })
                .catch(error =>{
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                })
        }
        else{
            toast.error(`For rejection remark can't be blank !`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
            });
        }
    
    }

    const handleRequestBkup = async (event) => {
        setCartDetails(false);
        const jsonData = {
            bkuprequest: {
                level: event.lvl
            }
        };
        await Axios.post(`/cart/bkuprequest/${cartDetails.refnum}`, jsonData)
            .then(async (data) => {
                setCartDetails(data.data.data.carth)
                toast.success(`Request for backup approver sent successfully.`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            })
            .catch(error => {
                toast.error(error.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            })
    }

    const selectHandler = (selectedList, selectedItem, level) => {
        console.log(selectedList, selectedItem);
        updateSelectedApprover(selectedList, level);
    }

    useEffect(() => {
        setJustForShow(props.justForShow);
        if (props.carth) setCartDetails(props.carth);

        if (approvers?.approver1) {
            updateSelectedApprover(approvers?.approver1, 1);
        }
        if (approvers?.approver2) {
            updateSelectedApprover(approvers?.approver2, 2);
        }
        if (approvers?.approver3) {
            updateSelectedApprover(approvers?.approver3, 3);
        }
    }, [props.carth]);

    const [approverList1, setApproverList1] = useState(false);
    const [showApproverEdit1, setShowApproverEdit1] = useState(false);

    const getApproverList = async () => {
        await Axios.get(`/cart/approverlist/${cartDetails.refnum}`)
            .then(async (response) => {
                if(response.success)
                {
                    setApproverList1(response.data.data.approvers?.[0]?.approver1)
                }
                else{
                    toast.error(response.error, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            })
            .catch(error => {
                toast.error(error.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            })
    }

    const sendRequest = async (item) => {
        console.log(item);
        await Axios.post(`/cart/requestaddapprover/${cartDetails.refnum}`, { username: item.username })
            .then(async (response) => {
                if (response.success) {
                    setApproverList1(response.data.data.approvers?.[0]?.approver1)
                }
                else {
                    toast.error(response.error, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            })
            .catch(error => {
                toast.error(error.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            })
    }

    return (
    <>
      <Formik>
          {() => (
            <>
            {cartDetails && <>
                <Row style={{display: "flex", margin:"auto 5px"}}>
                    <div className='col-md-2' style={{margin:"auto"}}>{`Approver 1`}</div>
                    <div className='col-md-2'>
                        <InputField Name={`approver1status`} ReadOnly={true} value={cartDetails.approver1status} Labels="Status" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver1`} ReadOnly={true} value={cartDetails.approver1} Labels="Approved/Rejected By" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver1date`} ReadOnly={true} value={cartDetails.approver1date?cartDetails.approver1date.split('T')[0]:""} Labels="Approved/Rejected Date" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver1comment`} ReadOnly={justForShow??false} defaultValue={cartDetails.approver1comment} onChange={(e)=>addRemark(e.target.value,1)} Labels="Remark" Type="text" />
                    </div>
                    <div className='col-md-2' style={{margin:"auto 5px"}}>
                    {cartDetails.approver1bkrequestaccess &&
                        <>
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleRequestBkup({lvl:1})}>Request Backup Approver</button>
                        </>
                    }    
                    {cartDetails.approver1access &&
                        <>
                        <button className='btn' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:1,result:'a'})}>Approve</button>|
                        <button className='btn' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:1,result:'r'})}>Reject</button>
                        </>
                    }
                    </div>
                </Row >
                {approvers?.approver1?.length>0 && <Row style={{ display: "flex", margin: "auto" }}>
                    <div className='col-md-2'></div>
                    <div style = {{paddingLeft: "15px"}}>
                        <Multiselect
                            options={approvers?.approver1}
                            selectedValues={approvers?.approver1.length > 1 ? [] : approvers?.approver1} 
                            placeholder="Select approver(s)"
                            displayValue="name"
                            onSelect = {(selectedList, selectedItem)=>selectHandler(selectedList, selectedItem, 1)}
                            onRemove = {(selectedList, selectedItem)=>selectHandler(selectedList, selectedItem, 1)}>
                        </Multiselect>
                    </div>
                </Row>}
                {cartDetails.status == 'S' && !cartDetails.approver1access &&
                <Row style={{ display: "flex", margin: "auto" }}>
                    <div className='col-md-2'></div>
                    <div style = {{paddingLeft: "15px"}}>
                        <button className='button btn-proceed-checkout' onClick={()=>{getApproverList();setShowApproverEdit1(true)}}>View Approver(s)</button>
                    </div>
                </Row>}
                {cartDetails.approver2status!='NA' &&
                <Row style={{display: "flex", margin:"auto"}}>
                    <div className='col-md-2' style={{margin:"auto 5px"}}>{`Approver 2`}</div>
                    <div className='col-md-2'>
                        <InputField Name={`approver2status`} ReadOnly={true} value={cartDetails.approver2status} Labels="Status" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver2`} ReadOnly={true} value={cartDetails.approver2} Labels="Approved/Rejected By" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver2date`} ReadOnly={true} value={cartDetails.approver2date?cartDetails.approver2date.split('T')[0]:""} Labels="Approved/Rejected Date" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver2comment`} ReadOnly={justForShow??false} defaultValue={cartDetails.approver2comment} onChange={(e)=>addRemark(e.target.value,2)} Labels="Remark" Type="text" />
                    </div>
                    
                    <div className='col-md-2' style={{margin:"auto 5px"}}>
                    {cartDetails.approver2bkrequestaccess &&
                        <>
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleRequestBkup({lvl:1})}>Request Backup Approver</button>
                        </>
                    }
                    {cartDetails.approver2access &&
                        <>
                        <button className='btn' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:2,result:'a'})}>Approve</button>|
                        <button className='btn' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:2,result:'r'})}>Reject</button>
                        </>
                    }
                    </div>
                </Row>}
                {cartDetails.approver3status!='NA' &&
                <Row style={{display: "flex", margin:"auto"}}>
                    <div className='col-md-2' style={{margin:"auto 5px"}}>{`Approver 3`}</div>
                    <div className='col-md-2'>
                        <InputField Name={`approver3status`} ReadOnly={true} value={cartDetails.approver3status} Labels="Status" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver3`} ReadOnly={true} value={cartDetails.approver3} Labels="Approved/Rejected By" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver3date`} ReadOnly={true} value={cartDetails.approver3date?cartDetails.approver3date.split('T')[0]:""} Labels="Approved/Rejected Date" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver3comment`} ReadOnly={justForShow??false} defaultValue={cartDetails.approver3comment} onChange={(e)=>addRemark(e.target.value,3)} Labels="Remark" Type="text" />
                    </div>
                    <div className='col-md-2' style={{margin:"auto 5px"}}>
                    {cartDetails.approver3bkrequestaccess &&
                        <>
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleRequestBkup({lvl:3})}>Request Backup Approver</button>
                        </>
                    }
                    {cartDetails.approver3access &&
                        <>
                        <button className='btn' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:3,result:'a'})}>Approve</button>|
                        <button className='btn' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:3,result:'r'})}>Reject</button>
                        </>
                    }
                    </div>
                </Row>}
                </>
            }
            </>
          )}
        </Formik>
            <Modal show={showApproverEdit1} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setShowApproverEdit1(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Approver List</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                    <div className="order-detail-content">
                        <Table responsive className="osya table-bordered jtv-cart-summary">
                            <thead>
                                <tr>
                                    <th>Approver</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {
                                approverList1 ?
                                    <>
                                        <tbody>
                                            {approverList1?.map((item, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td className="cart_description">
                                                            <p className="product-name">{item.name} </p>
                                                        </td>
                                                        <td className="action">
                                                            {item.requested ?
                                                                <small>Requested</small>
                                                                :
                                                                <small className="cart_ref">
                                                                    <button style={{ float: "left", padding: "3px 5px", marginTop: "5px" }}
                                                                        className="button btn-proceed-checkout"
                                                                        title="Request" type="button"
                                                                        onClick={() => sendRequest(item)}
                                                                    >
                                                                        {item.requested ? 'Requested' : 'Send Request'}
                                                                    </button>
                                                                </small>
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                            }
                                        </tbody>
                                    </>
                                    :
                                    <>
                                        <tbody>
                                            <tr>
                                                <td colSpan={8} style={{ textAlign: "center" }}>
                                                    No Details !
                                                </td>
                                            </tr>
                                        </tbody>
                                    </>
                            }
                        </Table>
                    </div>
                </Modal.Body>
            </Modal>
    </>
    )
}

export default ApprovalSetting